"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInterval = exports.useCountdown = void 0;
var useCountdown_1 = __importDefault(require("./useCountdown"));
exports.useCountdown = useCountdown_1.default;
var useInterval_1 = __importDefault(require("./useInterval"));
exports.useInterval = useInterval_1.default;
